var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverlayImgTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 454.257,
    height: 209.387,
    viewBox: "0 0 454.257 209.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.511,
    height: 14.572,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.256,
    height: 57.39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.757,
    height: 28.847,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.256,
    height: 57.383,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.253,
    height: 114.471,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.256,
    height: 57.386,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.25,
    height: 57.39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.508,
    height: 14.572,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.757,
    height: 28.841,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.253,
    height: 95.22,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.946,
    height: 9.598,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.253,
    height: 38.135,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.757,
    height: 23.867,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.511,
    height: 14.575,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.505,
    height: 14.578,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.256,
    height: 38.135,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.756,
    height: 28.847,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.51,
    height: 14.578,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.25,
    height: 38.135,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.941,
    height: 9.598,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.505,
    height: 14.575,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.505,
    height: 14.572,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.248,
    height: 114.475,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.51,
    height: 14.572,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.256,
    height: 57.389,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.948,
    height: 9.598,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.763,
    height: 23.867,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.51,
    height: 14.575,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.252,
    height: 114.475,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.303,
    height: 44.19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bj"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.049,
    height: 15.647,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bn"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.795,
    height: 101.274,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.795,
    height: 88.62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bp"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.303,
    height: 44.189,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bq"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.146,
    height: 2.999,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bs"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.303,
    height: 44.187,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bt"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.303,
    height: 31.541,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bu"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.125,
    height: 3.154,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bv"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.124,
    height: 3.153,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bw"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.13,
    height: 3.154,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.127,
    height: 3.153,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.128,
    height: 3.153,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.125,
    height: 3.153,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.127,
    height: 3.156,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.128,
    height: 3.154,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ch"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.124,
    height: 3.154,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ci"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.13,
    height: 3.159,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cj"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.125,
    height: 3.159,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ck"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.131,
    height: 3.153,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "co"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.124,
    height: 3.159,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cp"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.131,
    height: 3.159,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cx"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.132,
    height: 3.153,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cy"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.132,
    height: 3.154,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cz"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.131,
    height: 3.154,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "db"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.127,
    height: 3.154,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.127,
    height: 3.159,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dt"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.129,
    height: 3.153,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ek"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.122,
    height: 3.154,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "em"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.132,
    height: 3.159,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "er"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.487,
    height: 3.159,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-835.403 -2257.728)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(951.764 2336.218)",
    opacity: 0.565
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.823,348.177l-6.255-3.641v-7.29l.069-.034,6.187-3.607,6.255,3.641v7.29l-.063.035Zm-5.991-3.8,5.991,3.493,6-3.493V337.4l-6-3.492-5.991,3.492Z",
    transform: "translate(-494.568 -333.605)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(835.403 2314.809)",
    opacity: 0.766
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.628,300l-.066-.04L0,285.653V256.961l.066-.04,24.562-14.309.066.041,24.562,14.308v28.691l-.066.04ZM.261,285.5,24.628,299.7,48.994,285.5V257.11L24.628,242.917.261,257.11Z",
    transform: "translate(0 -242.612)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(853.776 2336.218)",
    opacity: 0.579
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.343,348.177l-6.256-3.641v-7.29l.067-.034,6.189-3.607,6.255,3.641v7.29l-.066.035Zm-5.994-3.8,5.994,3.493,5.994-3.493V337.4l-5.994-3.492L78.349,337.4Z",
    transform: "translate(-78.087 -333.605)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(896.647 2414.705)",
    opacity: 0.901
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.681,696.044,260.3,688.83V674.412l.066-.04,12.313-7.175,12.378,7.215V688.83l-.064.04Zm-12.118-7.364,12.118,7.059,12.12-7.059V674.561l-12.12-7.06-12.118,7.06Z",
    transform: "translate(-260.302 -667.197)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884.398 2400.437)",
    opacity: 0.856
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.868,663.938,208.24,649.6V620.9l.066-.034,24.562-14.308L257.5,620.9v28.7l-.063.035ZM208.5,649.44l24.367,14.194,24.369-14.194V621.053l-24.369-14.194L208.5,621.053Z",
    transform: "translate(-208.24 -606.555)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(908.896 2257.728)",
    opacity: 0.936
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.489,114.471l-.064-.041-49.06-28.577V28.617l.066-.038L361.489,0l.069.037,49.06,28.58V85.854l-.069.034ZM312.627,85.7l48.862,28.467L410.354,85.7V28.769L361.489.3,312.627,28.769Z",
    transform: "translate(-312.365 0)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884.398 2257.728)",
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.868,57.385l-.063-.04L208.24,43.037V14.345l.066-.037L232.868,0l.066.037L257.5,14.345V43.037l-.063.04ZM208.5,42.887l24.367,14.193,24.369-14.193V14.5L232.868.3,208.5,14.5Z",
    transform: "translate(-208.24 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(982.392 2314.809)",
    opacity: 0.921
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.367,300l-.064-.04-24.562-14.308V256.961l.064-.04,24.562-14.309.063.041,24.562,14.308v28.691l-.063.04ZM625,285.5,649.367,299.7,673.734,285.5V257.11l-24.366-14.194L625,257.11Z",
    transform: "translate(-624.742 -242.612)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945.641 2357.621)",
    opacity: 0.778
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.921,453.42l-12.378-7.209V431.787l.069-.04,12.31-7.174,12.379,7.214v14.424l-.064.034Zm-12.115-7.364,12.115,7.06,12.12-7.06V431.937l-12.12-7.06-12.115,7.06Z",
    transform: "translate(-468.543 -424.573)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(902.773 2336.218)",
    opacity: 0.612
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.593,348.177l-6.253-3.641v-7.29l.064-.034,6.189-3.607,6.256,3.641v7.29l-.067.035Zm-5.994-3.8,5.994,3.493,5.994-3.493V337.4l-5.994-3.492L286.6,337.4Z",
    transform: "translate(-286.34 -333.605)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(994.638 2329.084)",
    opacity: 0.698
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.173,332.123l-12.379-7.209V310.491l.063-.035,12.316-7.174,12.379,7.209v14.423l-.063.04Zm-12.12-7.364,12.12,7.06,12.12-7.06V310.64l-12.12-7.054-12.12,7.054Z",
    transform: "translate(-676.794 -303.282)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(982.392 2371.895)",
    opacity: 0.816
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.367,542.63l-.064-.041-24.562-14.308V499.589l.064-.04,24.562-14.308.063.04,24.562,14.308v28.692l-.063.035ZM625,528.125l24.367,14.2,24.366-14.2V499.739l-24.366-14.194L625,499.739Z",
    transform: "translate(-624.742 -485.24)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(908.896 2371.895)",
    opacity: 0.572
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.968,580.46l-16.342-9.518V514.006l48.862-28.462,48.865,28.462v56.936l-16.342,9.518h.523l16.014-9.328.069-.041V513.857l-49.06-28.577-.069-.04-49.057,28.577-.066.041v57.234l16.081,9.369Z",
    transform: "translate(-312.365 -485.24)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(941.548 2457.516)",
    opacity: 0.868
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.67,858.755l15.948-9.294,15.951,9.294h.523l-16.474-9.6-16.471,9.6Z",
    transform: "translate(-451.147 -849.157)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(908.896 2428.979)",
    opacity: 0.547
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.627,766v-9.369l48.862-28.462,48.865,28.462V766h.264v-9.518L361.558,727.9l-.069-.035-49.057,28.577-.066.04V766Z",
    transform: "translate(-312.365 -727.867)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(933.395 2400.437)",
    opacity: 0.883
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.117,663.938,416.492,649.6V620.9l.063-.034,24.562-14.308L465.748,620.9v28.7l-.069.035Zm-24.367-14.5,24.367,14.194,24.367-14.194V621.053l-24.367-14.194L416.75,621.053Z",
    transform: "translate(-416.492 -606.555)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(994.638 2443.248)",
    opacity: 0.525
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M681.149,812.379l-4.1-2.384V795.875l12.12-7.06,12.12,7.06v14.119l-4.1,2.384h.523l3.831-2.234V795.721l-12.379-7.209-12.378,7.209v14.423l3.831,2.234Z",
    transform: "translate(-676.795 -788.512)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(941.548 2457.516)",
    opacity: 0.753
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.67,858.755l15.948-9.294,15.951,9.294h.523l-16.474-9.6-16.471,9.6Z",
    transform: "translate(-451.147 -849.157)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(951.764 2279.133)",
    opacity: 0.893
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.823,105.552l-6.255-3.644V94.621l.069-.037,6.187-3.608,6.255,3.644v7.287l-.063.041Zm-5.991-3.8,5.991,3.493,6-3.493V94.774l-6-3.492-5.991,3.492Z",
    transform: "translate(-494.568 -90.977)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1043.636 2271.999)",
    opacity: 0.838
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M897.426,89.5l-12.378-7.214V67.867l.063-.037,12.315-7.175L909.8,67.867V82.288l-.069.04Zm-12.12-7.367,12.12,7.063,12.114-7.063V68.019l-12.114-7.06-12.12,7.06Z",
    transform: "translate(-885.048 -60.655)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(994.638 2357.621)",
    opacity: 0.665
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.173,453.42l-12.379-7.209V431.787l.063-.04,12.316-7.174,12.379,7.214v14.424l-.063.034Zm-12.12-7.364,12.12,7.06,12.12-7.06V431.937l-12.12-7.06-12.12,7.06Z",
    transform: "translate(-676.794 -424.573)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(951.764 2336.218)",
    opacity: 0.626
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.823,348.177l-6.255-3.641v-7.29l.069-.034,6.187-3.607,6.255,3.641v7.29l-.063.035Zm-5.991-3.8,5.991,3.493,6-3.493V337.4l-6-3.492-5.991,3.492Z",
    transform: "translate(-494.568 -333.605)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(951.764 2393.303)",
    opacity: 0.519
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.823,590.8l-6.255-3.648v-7.284l.069-.04,6.187-3.6,6.255,3.642v7.284l-.063.04Zm-5.991-3.8,5.991,3.493,6-3.493v-6.985l-6-3.492-5.991,3.492Z",
    transform: "translate(-494.568 -576.232)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1031.383 2371.895)",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.6,542.63l-.069-.041L832.97,528.281V499.589l.063-.04L857.6,485.24l.064.04,24.562,14.308v28.692l-.064.035Zm-24.372-14.5,24.372,14.2,24.366-14.2V499.739L857.6,485.545l-24.372,14.194Z",
    transform: "translate(-832.97 -485.24)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1049.759 2450.382)",
    opacity: 0.517
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917.327,833.413l-6.255-3.647v-7.284l6.255-3.647,6.25,3.647v7.284Zm-6-3.8,6,3.492,5.991-3.492v-6.985l-5.991-3.493-6,3.493Z",
    transform: "translate(-911.072 -818.835)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1031.383 2428.979)",
    opacity: 0.648
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.228,766V742.365L857.6,728.172l24.366,14.193V766h.259V742.21L857.664,727.9l-.063-.035-24.567,14.308-.064.035V766Z",
    transform: "translate(-832.97 -727.867)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092.628 2271.999)",
    opacity: 0.986
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1105.653,89.5l-12.378-7.214V67.867l.069-.037,12.309-7.175,12.379,7.212V82.288l-.063.04Zm-12.12-7.367,12.12,7.063,12.12-7.063V68.019l-12.12-7.06-12.12,7.06Z",
    transform: "translate(-1093.276 -60.655)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1080.38 2371.895)",
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1065.847,542.63l-.063-.041-24.562-14.308V499.589l.063-.04,24.561-14.308.069.04,24.561,14.308v28.692l-.069.035Zm-24.366-14.5,24.366,14.2,24.367-14.2V499.739l-24.367-14.194-24.366,14.194Z",
    transform: "translate(-1041.222 -485.24)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1006.885 2371.895)",
    opacity: 0.806
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M745.451,580.46l-16.342-9.518V514.006l48.865-28.462,48.866,28.462v56.936L810.5,580.46h.517l16.021-9.328.063-.041V513.857l-49.06-28.577-.063-.04-49.06,28.577-.069.041v57.234l16.084,9.369Z",
    transform: "translate(-728.845 -485.24)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1098.75 2450.382)",
    opacity: 0.998
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1125.555,833.413l-6.255-3.647v-7.284l6.255-3.647,6.255,3.647v7.284Zm-5.991-3.8,5.991,3.492,6-3.492v-6.985l-6-3.493-5.991,3.493Z",
    transform: "translate(-1119.3 -818.835)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(982.392 2428.979)",
    opacity: 0.632
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625,766V742.365l24.367-14.193,24.366,14.193V766h.259V742.21L649.431,727.9l-.063-.035-24.562,14.308-.063.035V766Z",
    transform: "translate(-624.742 -727.867)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1000.762 2450.382)",
    opacity: 0.577
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.075,833.413l-6.255-3.647v-7.284l6.255-3.647,6.255,3.647v7.284Zm-6-3.8,6,3.492,6-3.492v-6.985l-6-3.493-6,3.493Z",
    transform: "translate(-702.82 -818.835)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(982.392 2428.979)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625,766V742.365l24.367-14.193,24.366,14.193V766h.259V742.21L649.431,727.9l-.063-.035-24.562,14.308-.063.035V766Z",
    transform: "translate(-624.742 -727.867)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1039.54 2457.516)",
    opacity: 0.601
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M868.162,858.755l15.951-9.294,15.946,9.294h.522l-16.468-9.6-16.473,9.6Z",
    transform: "translate(-867.64 -849.157)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1049.759 2279.133)",
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917.327,105.552l-6.255-3.644V94.621l.063-.037,6.192-3.608,6.25,3.644v7.287l-.063.041Zm-6-3.8,6,3.493,5.991-3.493V94.774l-5.991-3.492-6,3.492Z",
    transform: "translate(-911.072 -90.977)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1049.759 2336.218)",
    opacity: 0.916
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917.327,348.177l-6.255-3.641v-7.29l.063-.034,6.192-3.607,6.25,3.641v7.29l-.063.035Zm-6-3.8,6,3.493,5.991-3.493V337.4l-5.991-3.492-6,3.492Z",
    transform: "translate(-911.072 -333.605)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1031.383 2371.895)",
    opacity: 0.558
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.6,542.63l-.069-.041L832.97,528.281V499.589l.063-.04L857.6,485.24l.064.04,24.562,14.308v28.692l-.064.035Zm-24.372-14.5,24.372,14.2,24.366-14.2V499.739L857.6,485.545l-24.372,14.194Z",
    transform: "translate(-832.97 -485.24)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1141.625 2386.163)",
    opacity: 0.664
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1313.9,574.731l-12.379-7.209V553.1l.064-.04,12.315-7.174,12.379,7.215v14.423l-.063.035Zm-12.12-7.364,12.12,7.06,12.12-7.06V553.248l-12.12-7.06-12.12,7.06Z",
    transform: "translate(-1301.526 -545.884)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1080.38 2400.437)",
    opacity: 0.948
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1065.847,663.938,1041.222,649.6V620.9l.063-.034,24.561-14.308,24.631,14.343v28.7l-.069.035Zm-24.366-14.5,24.366,14.194,24.367-14.194V621.053l-24.367-14.194-24.366,14.194Z",
    transform: "translate(-1041.222 -606.555)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1104.879 2314.809)",
    opacity: 0.829
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#an)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1194.473,357.087l-.063-.041-49.06-28.583V271.229l.063-.035,49.06-28.583.064.041,49.06,28.577v57.234l-.064.041Zm-48.865-28.772,48.865,28.467,48.865-28.467v-56.93l-48.865-28.467-48.865,28.467Z",
    transform: "translate(-1145.35 -242.612)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1098.75 2336.218)",
    opacity: 0.963
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1125.555,348.177l-6.255-3.641v-7.29l.069-.034,6.186-3.607,6.255,3.641v7.29l-.063.035Zm-5.991-3.8,5.991,3.493,6-3.493V337.4l-6-3.492-5.991,3.492Z",
    transform: "translate(-1119.3 -333.605)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1178.369 2314.809)",
    opacity: 0.688
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1482.333,300l-.069-.04L1457.7,285.653V256.961l.063-.04,24.568-14.309.063.041,24.562,14.308v28.691l-.063.04Zm-24.372-14.5,24.372,14.194L1506.7,285.5V257.11l-24.367-14.194L1457.96,257.11Z",
    transform: "translate(-1457.702 -242.612)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1141.625 2414.705)",
    opacity: 0.554
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1313.9,696.044l-12.379-7.214V674.412l.064-.04L1313.9,667.2l12.379,7.215V688.83l-.063.04Zm-12.12-7.364,12.12,7.059,12.12-7.059V674.561l-12.12-7.06-12.12,7.06Z",
    transform: "translate(-1301.526 -667.197)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1129.372 2343.352)",
    opacity: 0.802
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1274.081,421.316l-.063-.04-24.568-14.308V378.275l.069-.04,24.562-14.308.063.04,24.561,14.308v28.692l-.063.04Zm-24.367-14.5,24.367,14.194,24.367-14.194V378.425l-24.367-14.194-24.367,14.194Z",
    transform: "translate(-1249.45 -363.927)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1137.529 2457.516)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1284.64,858.755l15.951-9.294,15.951,9.294h.523l-16.474-9.6-16.474,9.6Z",
    transform: "translate(-1284.117 -849.157)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1080.38 2428.979)",
    opacity: 0.757
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1041.481,766V742.365l24.366-14.193,24.366,14.193V766h.264V742.21L1065.916,727.9l-.069-.035-24.562,14.308-.063.035V766Z",
    transform: "translate(-1041.222 -727.867)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1129.372 2400.437)",
    opacity: 0.934
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1274.081,663.938,1249.45,649.6V620.9l.069-.034,24.562-14.308,24.625,14.343v28.7l-.063.035Zm-24.367-14.5,24.367,14.194,24.367-14.194V621.053l-24.367-14.194-24.367,14.194Z",
    transform: "translate(-1249.45 -606.555)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1190.615 2443.248)",
    opacity: 0.672
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1514.106,812.379l-4.09-2.384V795.875l12.12-7.06,12.115,7.06v14.119l-4.09,2.384h.517l3.837-2.234V795.721l-12.378-7.209-12.385,7.209v14.423l3.837,2.234Z",
    transform: "translate(-1509.751 -788.512)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1137.529 2457.516)",
    opacity: 0.565
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1284.64,858.755l15.951-9.294,15.951,9.294h.523l-16.474-9.6-16.474,9.6Z",
    transform: "translate(-1284.117 -849.157)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1147.747 2279.133)",
    opacity: 0.711
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ax)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1333.805,105.552l-6.255-3.644V94.621l.063-.037,6.192-3.608,6.255,3.644v7.287l-.069.041Zm-6-3.8,6,3.493,5.991-3.493V94.774l-5.991-3.492-6,3.492Z",
    transform: "translate(-1327.55 -90.977)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1129.372 2257.728)",
    opacity: 0.631
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1274.081,57.385l-.063-.04L1249.45,43.037V14.345l.069-.037L1274.081,0l.063.037,24.561,14.308V43.037l-.063.04Zm-24.367-14.5,24.367,14.193,24.367-14.193V14.5L1274.081.3,1249.714,14.5Z",
    transform: "translate(-1249.45 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1227.365 2257.728)",
    opacity: 0.928
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1690.579,57.385l-.063-.04-24.562-14.308V14.345l.063-.037L1690.579,0l24.63,14.346V43.037l-.069.04Zm-24.367-14.5,24.367,14.193,24.367-14.193V14.5L1690.579.3,1666.212,14.5Z",
    transform: "translate(-1665.953 0.001)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1227.365 2314.809)",
    opacity: 0.639
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1690.579,300l-24.625-14.349V256.961l.063-.04,24.562-14.309,24.63,14.349v28.691l-.069.04Zm-24.367-14.5,24.367,14.194,24.367-14.194V257.11l-24.367-14.194-24.367,14.194Z",
    transform: "translate(-1665.953 -242.612)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1153.871 2314.809)",
    opacity: 0.894
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1402.706,357.087l-.069-.041-49.06-28.583V271.229l.069-.035,49.06-28.583.063.041,49.061,28.577v57.234l-.063.041Zm-48.865-28.772,48.865,28.467,48.865-28.467v-56.93l-48.865-28.467-48.865,28.467Z",
    transform: "translate(-1353.578 -242.612)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1147.747 2336.218)",
    opacity: 0.653
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1333.805,348.177l-6.255-3.641v-7.29l.063-.034,6.192-3.607,6.255,3.641v7.29l-.069.035Zm-6-3.8,6,3.493,5.991-3.493V337.4l-5.991-3.492-6,3.492Z",
    transform: "translate(-1327.55 -333.605)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1147.747 2393.303)",
    opacity: 0.621
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1333.805,590.8l-6.255-3.648v-7.284l.063-.04,6.192-3.6,6.255,3.642v7.284l-.069.04Zm-6-3.8,6,3.493,5.991-3.493v-6.985l-5.991-3.492-6,3.492Z",
    transform: "translate(-1327.55 -576.232)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1245.736 2450.382)",
    opacity: 0.992
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1750.285,833.413l-6.256-3.647v-7.284l6.256-3.647,6.255,3.647v7.284Zm-5.991-3.8,5.991,3.492,6-3.492v-6.985l-6-3.493-5.991,3.493Z",
    transform: "translate(-1744.029 -818.835)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1196.744 2336.218)",
    opacity: 0.521
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1542.058,348.177l-6.256-3.641v-7.29l.063-.034,6.192-3.607,6.249,3.641v7.29l-.063.035Zm-6-3.8,6,3.493,5.991-3.493V337.4l-5.991-3.492-6,3.492Z",
    transform: "translate(-1535.802 -333.605)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1178.369 2314.809)",
    opacity: 0.509
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1482.333,300l-.069-.04L1457.7,285.653V256.961l.063-.04,24.568-14.309.063.041,24.562,14.308v28.691l-.063.04Zm-24.372-14.5,24.372,14.194L1506.7,285.5V257.11l-24.367-14.194L1457.96,257.11Z",
    transform: "translate(-1457.702 -242.612)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1276.357 2378.494)",
    opacity: 0.646
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1887.485,557.176l-13.039-7.6V521.19l13.039-7.6v-.3L1874.251,521l-.069.04v28.692l13.3,7.749Z",
    transform: "translate(-1874.182 -513.292)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1227.365 2400.437)",
    opacity: 0.507
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1690.579,663.938,1665.954,649.6V620.9l.063-.034,24.562-14.308,24.63,14.343v28.7l-.069.035Zm-24.367-14.5,24.367,14.194,24.367-14.194V621.053l-24.367-14.194-24.367,14.194Z",
    transform: "translate(-1665.953 -606.555)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1288.61 2392.763)",
    opacity: 0.654
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1927.308,589.28l-.793-.46V574.7l.793-.46v-.3l-.988.574-.063.04v14.423l1.051.609Z",
    transform: "translate(-1926.258 -573.937)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1235.518 2457.516)",
    opacity: 0.716
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1701.12,858.755l15.951-9.294,15.951,9.294h.523l-16.474-9.6-16.474,9.6Z",
    transform: "translate(-1700.597 -849.157)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1178.369 2428.979)",
    opacity: 0.688
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1457.96,766V742.365l24.372-14.193,24.367,14.193V766h.258V742.21L1482.4,727.9l-.063-.035-24.562,14.308-.069.035V766Z",
    transform: "translate(-1457.702 -727.867)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1227.365 2400.437)",
    opacity: 0.854
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1690.579,663.938,1665.954,649.6V620.9l.063-.034,24.562-14.308,24.63,14.343v28.7l-.069.035Zm-24.367-14.5,24.367,14.194,24.367-14.194V621.053l-24.367-14.194-24.367,14.194Z",
    transform: "translate(-1665.953 -606.555)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1251.865 2321.41)",
    opacity: 0.811
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bn)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1807.876,371.634l-37.538-21.867v-56.93l37.538-21.867v-.3l-37.733,21.983-.064.035v57.234l37.8,22.023Z",
    transform: "translate(-1770.08 -270.665)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1251.865 2378.494)",
    opacity: 0.635
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bo)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1786.681,601.912l-16.342-9.518V535.458l37.538-21.867v-.3l-37.733,21.977-.063.041v57.234l16.077,9.369Z",
    transform: "translate(-1770.08 -513.292)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1276.357 2349.952)",
    opacity: 0.997
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bp)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1887.485,435.865l-13.039-7.594V399.878l13.039-7.594v-.3l-13.234,7.708-.069.04V428.42l13.3,7.749Z",
    transform: "translate(-1874.182 -391.98)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1284.514 2464.116)",
    opacity: 0.977
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1909.373,880.206l4.624-2.694v-.3l-5.147,3Z",
    transform: "translate(-1908.85 -877.207)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1284.514 2464.116)",
    opacity: 0.634
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1909.373,880.206l4.624-2.694v-.3l-5.147,3Z",
    transform: "translate(-1908.85 -877.207)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1276.357 2264.327)",
    opacity: 0.854
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bs)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1887.485,71.937l-13.039-7.6V35.947l13.039-7.6v-.3l-13.234,7.709-.069.037V64.487l13.3,7.748Z",
    transform: "translate(-1874.182 -28.049)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1276.357 2435.574)",
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bt)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1874.447,787.436V763.8l13.039-7.6v-.3l-13.235,7.714-.069.035v23.792Z",
    transform: "translate(-1874.182 -755.895)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(950.334 2345.494)",
    opacity: 0.814
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.612,374.612a1.563,1.563,0,1,1-1.562-1.58,1.57,1.57,0,0,1,1.562,1.58",
    transform: "translate(-488.487 -373.032)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(956.458 2349.062)",
    opacity: 0.728
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bv)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.64,389.774a1.562,1.562,0,1,1-1.562-1.579,1.567,1.567,0,0,1,1.562,1.579",
    transform: "translate(-514.515 -388.195)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(962.581 2345.494)",
    opacity: 0.759
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.67,374.612a1.565,1.565,0,1,1-1.568-1.58,1.571,1.571,0,0,1,1.568,1.58",
    transform: "translate(-540.54 -373.032)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(858.469 2370.47)",
    opacity: 0.765
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.16,480.759a1.562,1.562,0,1,1-1.562-1.574,1.569,1.569,0,0,1,1.562,1.574",
    transform: "translate(-98.035 -479.185)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(852.343 2338.361)",
    opacity: 0.933
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.125,344.286a1.564,1.564,0,1,1-1.562-1.573,1.571,1.571,0,0,1,1.562,1.573",
    transform: "translate(-71.998 -342.713)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(919.712 2434.689)",
    opacity: 0.692
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bv)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.461,753.709a1.562,1.562,0,1,1-1.562-1.574,1.569,1.569,0,0,1,1.562,1.574",
    transform: "translate(-358.337 -752.135)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(882.964 2441.823)",
    opacity: 0.517
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.275,784.031a1.564,1.564,0,1,1-1.563-1.574,1.572,1.572,0,0,1,1.563,1.574",
    transform: "translate(-202.147 -782.457)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(931.962 2413.281)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.525,662.724a1.563,1.563,0,1,1-1.563-1.579,1.57,1.57,0,0,1,1.563,1.579",
    transform: "translate(-410.4 -661.145)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(882.964 2413.281)",
    opacity: 0.812
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.275,662.724a1.564,1.564,0,1,1-1.563-1.579,1.57,1.57,0,0,1,1.563,1.579",
    transform: "translate(-202.147 -661.145)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(907.463 2341.927)",
    opacity: 0.733
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.4,359.446a1.564,1.564,0,1,1-1.565-1.574,1.572,1.572,0,0,1,1.565,1.574",
    transform: "translate(-306.275 -357.872)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(907.463 2284.843)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.4,116.825a1.564,1.564,0,1,1-1.565-1.58,1.571,1.571,0,0,1,1.565,1.58",
    transform: "translate(-306.275 -115.245)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(931.962 2299.117)",
    opacity: 0.523
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.525,177.489a1.563,1.563,0,1,1-1.563-1.574,1.57,1.57,0,0,1,1.563,1.574",
    transform: "translate(-410.4 -175.915)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(882.964 2270.574)",
    opacity: 0.785
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cg)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.275,56.177a1.564,1.564,0,1,1-1.563-1.577,1.571,1.571,0,0,1,1.563,1.577",
    transform: "translate(-202.147 -54.6)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(956.458 2384.738)",
    opacity: 0.942
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ch)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.64,541.41a1.562,1.562,0,1,1-1.562-1.58,1.567,1.567,0,0,1,1.562,1.58",
    transform: "translate(-514.515 -539.83)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(968.704 2363.33)",
    opacity: 0.835
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ci)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M569.7,450.419a1.565,1.565,0,1,1-1.562-1.579,1.571,1.571,0,0,1,1.562,1.579",
    transform: "translate(-566.565 -448.84)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(944.211 2363.33)",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.587,450.419a1.563,1.563,0,1,1-1.562-1.579,1.572,1.572,0,0,1,1.562,1.579",
    transform: "translate(-462.462 -448.84)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(993.202 2349.062)",
    opacity: 0.894
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ck)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.821,389.774a1.565,1.565,0,1,1-1.563-1.579,1.57,1.57,0,0,1,1.563,1.579",
    transform: "translate(-670.69 -388.195)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1005.454 2356.196)",
    opacity: 0.846
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M725.89,420.1a1.563,1.563,0,1,1-1.562-1.579,1.566,1.566,0,0,1,1.562,1.579",
    transform: "translate(-722.765 -418.518)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980.956 2413.281)",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M621.765,662.724a1.563,1.563,0,1,1-1.563-1.579,1.57,1.57,0,0,1,1.563,1.579",
    transform: "translate(-618.64 -661.145)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1005.454 2456.092)",
    opacity: 0.727
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M725.89,844.681a1.563,1.563,0,1,1-1.562-1.579,1.57,1.57,0,0,1,1.562,1.579",
    transform: "translate(-722.765 -843.102)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(956.458 2427.549)",
    opacity: 0.986
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#co)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.64,723.367a1.562,1.562,0,1,1-1.562-1.58,1.568,1.568,0,0,1,1.562,1.58",
    transform: "translate(-514.515 -721.787)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(993.202 2463.226)",
    opacity: 0.537
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.821,875a1.565,1.565,0,1,1-1.563-1.579A1.572,1.572,0,0,1,673.821,875",
    transform: "translate(-670.69 -873.425)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(956.458 2277.708)",
    opacity: 0.783
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ch)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.64,86.5a1.562,1.562,0,1,1-1.562-1.577A1.566,1.566,0,0,1,517.64,86.5",
    transform: "translate(-514.515 -84.922)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1017.701 2377.604)",
    opacity: 0.534
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M777.947,511.081a1.565,1.565,0,1,1-1.568-1.574,1.573,1.573,0,0,1,1.568,1.574",
    transform: "translate(-774.817 -509.507)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(993.202 2363.33)",
    opacity: 0.992
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.821,450.419a1.565,1.565,0,1,1-1.563-1.579,1.572,1.572,0,0,1,1.563,1.579",
    transform: "translate(-670.69 -448.84)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(950.334 2345.494)",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.612,374.612a1.563,1.563,0,1,1-1.562-1.58,1.57,1.57,0,0,1,1.562,1.58",
    transform: "translate(-488.487 -373.032)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(962.581 2395.44)",
    opacity: 0.808
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ci)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.67,586.893a1.565,1.565,0,1,1-1.568-1.579,1.573,1.573,0,0,1,1.568,1.579",
    transform: "translate(-540.54 -585.314)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1029.953 2413.281)",
    opacity: 0.766
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bv)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M830.016,662.724a1.562,1.562,0,1,1-1.562-1.579,1.57,1.57,0,0,1,1.562,1.579",
    transform: "translate(-826.892 -661.145)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1054.446 2427.549)",
    opacity: 0.543
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M934.123,723.367a1.566,1.566,0,1,1-1.563-1.58,1.571,1.571,0,0,1,1.563,1.58",
    transform: "translate(-930.992 -721.787)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1078.945 2413.281)",
    opacity: 0.854
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cx)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1038.25,662.724a1.565,1.565,0,1,1-1.568-1.579,1.571,1.571,0,0,1,1.568,1.579",
    transform: "translate(-1035.12 -661.145)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1078.945 2384.738)",
    opacity: 0.559
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cy)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1038.25,541.41a1.565,1.565,0,1,1-1.568-1.58,1.572,1.572,0,0,1,1.568,1.58",
    transform: "translate(-1035.12 -539.83)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1054.446 2370.47)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cz)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M934.123,480.759a1.566,1.566,0,1,1-1.563-1.574,1.572,1.572,0,0,1,1.563,1.574",
    transform: "translate(-930.992 -479.185)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1048.322 2452.524)",
    opacity: 0.609
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cz)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M908.1,829.52a1.566,1.566,0,1,1-1.568-1.58,1.572,1.572,0,0,1,1.568,1.58",
    transform: "translate(-904.967 -827.94)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1103.442 2270.574)",
    opacity: 0.578
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#db)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1142.37,56.177a1.563,1.563,0,1,1-1.563-1.577,1.567,1.567,0,0,1,1.563,1.577",
    transform: "translate(-1139.244 -54.6)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1103.442 2427.549)",
    opacity: 0.766
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1142.37,723.367a1.563,1.563,0,1,1-1.563-1.58,1.568,1.568,0,0,1,1.563,1.58",
    transform: "translate(-1139.244 -721.787)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1005.454 2456.092)",
    opacity: 0.566
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M725.89,844.681a1.563,1.563,0,1,1-1.562-1.579,1.57,1.57,0,0,1,1.562,1.579",
    transform: "translate(-722.765 -843.102)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1097.32 2459.658)",
    opacity: 0.912
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1116.345,859.842a1.563,1.563,0,1,1-1.563-1.58,1.572,1.572,0,0,1,1.563,1.58",
    transform: "translate(-1113.22 -858.262)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(999.331 2459.658)",
    opacity: 0.977
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M699.864,859.842a1.563,1.563,0,1,1-1.562-1.58,1.572,1.572,0,0,1,1.562,1.58",
    transform: "translate(-696.739 -858.262)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1048.322 2288.413)",
    opacity: 0.902
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ck)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M908.1,132a1.566,1.566,0,1,1-1.568-1.577A1.572,1.572,0,0,1,908.1,132",
    transform: "translate(-904.967 -130.419)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1054.446 2334.793)",
    opacity: 0.684
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ck)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M934.123,329.123a1.566,1.566,0,1,1-1.563-1.574,1.572,1.572,0,0,1,1.563,1.574",
    transform: "translate(-930.992 -327.549)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1152.441 2413.281)",
    opacity: 0.947
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1350.621,662.724a1.562,1.562,0,1,1-1.562-1.579,1.57,1.57,0,0,1,1.562,1.579",
    transform: "translate(-1347.498 -661.145)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1127.941 2413.281)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1246.5,662.724a1.562,1.562,0,1,1-1.562-1.579,1.57,1.57,0,0,1,1.562,1.579",
    transform: "translate(-1243.371 -661.145)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1103.442 2399.007)",
    opacity: 0.935
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1142.37,602.055a1.563,1.563,0,1,1-1.563-1.58,1.568,1.568,0,0,1,1.563,1.58",
    transform: "translate(-1139.244 -600.475)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1103.442 2341.927)",
    opacity: 0.572
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1142.37,359.446a1.563,1.563,0,1,1-1.563-1.574,1.568,1.568,0,0,1,1.563,1.574",
    transform: "translate(-1139.244 -357.872)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1109.566 2345.494)",
    opacity: 0.723
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cy)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1168.4,374.612a1.565,1.565,0,1,1-1.568-1.58,1.572,1.572,0,0,1,1.568,1.58",
    transform: "translate(-1165.27 -373.032)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1201.43 2313.385)",
    opacity: 0.789
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cx)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1558.855,238.138a1.565,1.565,0,1,1-1.562-1.579,1.57,1.57,0,0,1,1.562,1.579",
    transform: "translate(-1555.723 -236.559)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1176.938 2327.653)",
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1454.748,298.782a1.563,1.563,0,1,1-1.562-1.58,1.571,1.571,0,0,1,1.562,1.58",
    transform: "translate(-1451.622 -297.202)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1140.188 2420.415)",
    opacity: 0.543
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cy)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1298.552,693.045a1.565,1.565,0,1,1-1.562-1.58,1.57,1.57,0,0,1,1.562,1.58",
    transform: "translate(-1295.422 -691.465)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1176.938 2384.738)",
    opacity: 0.832
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1454.748,541.41a1.563,1.563,0,1,1-1.562-1.58,1.571,1.571,0,0,1,1.562,1.58",
    transform: "translate(-1451.622 -539.83)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1152.441 2456.092)",
    opacity: 0.551
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1350.621,844.681a1.562,1.562,0,1,1-1.562-1.579,1.57,1.57,0,0,1,1.562,1.579",
    transform: "translate(-1347.498 -843.102)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1103.442 2427.549)",
    opacity: 0.736
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1142.37,723.367a1.563,1.563,0,1,1-1.563-1.58,1.568,1.568,0,0,1,1.563,1.58",
    transform: "translate(-1139.244 -721.787)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1176.933 2441.823)",
    opacity: 0.569
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dt)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1454.73,784.031a1.565,1.565,0,1,1-1.562-1.574,1.572,1.572,0,0,1,1.562,1.574",
    transform: "translate(-1451.599 -782.457)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1127.941 2413.281)",
    opacity: 0.704
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1246.5,662.724a1.562,1.562,0,1,1-1.562-1.579,1.57,1.57,0,0,1,1.562,1.579",
    transform: "translate(-1243.371 -661.145)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1213.684 2463.226)",
    opacity: 0.947
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#co)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1610.925,875a1.563,1.563,0,1,1-1.563-1.579,1.572,1.572,0,0,1,1.563,1.579",
    transform: "translate(-1607.8 -873.425)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1201.43 2441.823)",
    opacity: 0.988
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cx)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1558.855,784.031a1.565,1.565,0,1,1-1.562-1.574,1.571,1.571,0,0,1,1.562,1.574",
    transform: "translate(-1555.723 -782.457)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1152.441 2277.708)",
    opacity: 0.576
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1350.621,86.5a1.562,1.562,0,1,1-1.562-1.577,1.569,1.569,0,0,1,1.562,1.577",
    transform: "translate(-1347.498 -84.922)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1127.941 2299.117)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1246.5,177.489a1.562,1.562,0,1,1-1.562-1.574,1.571,1.571,0,0,1,1.562,1.574",
    transform: "translate(-1243.371 -175.915)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1225.93 2299.117)",
    opacity: 0.655
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cx)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1662.981,177.489a1.566,1.566,0,1,1-1.568-1.574,1.573,1.573,0,0,1,1.568,1.574",
    transform: "translate(-1659.85 -175.915)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1250.43 2370.47)",
    opacity: 0.653
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1767.1,480.759a1.562,1.562,0,1,1-1.562-1.574,1.567,1.567,0,0,1,1.562,1.574",
    transform: "translate(-1763.978 -479.185)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1274.927 2356.196)",
    opacity: 0.799
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1871.227,420.1a1.563,1.563,0,1,1-1.563-1.579,1.567,1.567,0,0,1,1.563,1.579",
    transform: "translate(-1868.102 -418.518)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1146.317 2345.494)",
    opacity: 0.867
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1324.6,374.612a1.562,1.562,0,1,1-1.562-1.58,1.57,1.57,0,0,1,1.562,1.58",
    transform: "translate(-1321.472 -373.032)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1152.441 2334.793)",
    opacity: 0.879
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1350.621,329.123a1.562,1.562,0,1,1-1.562-1.574,1.571,1.571,0,0,1,1.562,1.574",
    transform: "translate(-1347.498 -327.549)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1146.317 2402.579)",
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1324.6,617.234a1.562,1.562,0,1,1-1.562-1.574,1.571,1.571,0,0,1,1.562,1.574",
    transform: "translate(-1321.472 -615.66)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1152.441 2406.147)",
    opacity: 0.997
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1350.621,632.4a1.562,1.562,0,1,1-1.562-1.573,1.571,1.571,0,0,1,1.562,1.573",
    transform: "translate(-1347.498 -630.823)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1158.563 2395.44)",
    opacity: 0.997
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1376.648,586.893a1.563,1.563,0,1,1-1.563-1.579,1.572,1.572,0,0,1,1.563,1.579",
    transform: "translate(-1373.522 -585.314)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1146.317 2395.44)",
    opacity: 0.596
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1324.6,586.893a1.562,1.562,0,1,1-1.562-1.579,1.571,1.571,0,0,1,1.562,1.579",
    transform: "translate(-1321.472 -585.314)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1250.43 2463.226)",
    opacity: 0.502
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1767.1,875a1.562,1.562,0,1,1-1.562-1.579A1.568,1.568,0,0,1,1767.1,875",
    transform: "translate(-1763.978 -873.425)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1250.43 2448.958)",
    opacity: 0.866
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1767.1,814.359a1.562,1.562,0,1,1-1.562-1.579,1.566,1.566,0,0,1,1.562,1.579",
    transform: "translate(-1763.978 -812.78)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1207.562 2345.494)",
    opacity: 0.671
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ek)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1584.9,374.612a1.562,1.562,0,1,1-1.562-1.58,1.57,1.57,0,0,1,1.562,1.58",
    transform: "translate(-1581.776 -373.032)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1195.309 2338.361)",
    opacity: 0.939
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dt)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1532.83,344.286a1.565,1.565,0,1,1-1.568-1.573,1.573,1.573,0,0,1,1.568,1.573",
    transform: "translate(-1529.7 -342.713)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1225.93 2327.653)",
    opacity: 0.826
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#em)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1662.981,298.782a1.566,1.566,0,1,1-1.568-1.58,1.573,1.573,0,0,1,1.568,1.58",
    transform: "translate(-1659.85 -297.202)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1201.43 2313.385)",
    opacity: 0.882
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cx)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1558.855,238.138a1.565,1.565,0,1,1-1.562-1.579,1.57,1.57,0,0,1,1.562,1.579",
    transform: "translate(-1555.723 -236.559)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1176.938 2327.653)",
    opacity: 0.725
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1454.748,298.782a1.563,1.563,0,1,1-1.562-1.58,1.571,1.571,0,0,1,1.562,1.58",
    transform: "translate(-1451.622 -297.202)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1274.927 2413.281)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1871.227,662.724a1.563,1.563,0,1,1-1.563-1.579,1.57,1.57,0,0,1,1.563,1.579",
    transform: "translate(-1868.102 -661.145)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1274.927 2384.738)",
    opacity: 0.717
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1871.227,541.41a1.563,1.563,0,1,1-1.563-1.58,1.571,1.571,0,0,1,1.563,1.58",
    transform: "translate(-1868.102 -539.83)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1287.173 2391.872)",
    opacity: 0.748
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#er)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1922.64,570.463a1.579,1.579,0,1,0,0,2.539Z",
    transform: "translate(-1920.151 -570.153)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1176.938 2441.823)",
    opacity: 0.931
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1454.748,784.031a1.562,1.562,0,1,1-1.562-1.574,1.571,1.571,0,0,1,1.562,1.574",
    transform: "translate(-1451.622 -782.457)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1274.927 2441.823)",
    opacity: 0.947
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1871.227,784.031a1.563,1.563,0,1,1-1.563-1.574,1.572,1.572,0,0,1,1.563,1.574",
    transform: "translate(-1868.102 -782.457)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1250.43 2341.927)",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1767.1,359.446a1.562,1.562,0,1,1-1.562-1.574,1.568,1.568,0,0,1,1.562,1.574",
    transform: "translate(-1763.978 -357.872)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1250.43 2399.007)",
    opacity: 0.59
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1767.1,602.055a1.562,1.562,0,1,1-1.562-1.58,1.568,1.568,0,0,1,1.562,1.58",
    transform: "translate(-1763.978 -600.475)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 454.257,
    height: 207.887,
    transform: "translate(835.403 2257.728)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayImgTop);
export default __webpack_public_path__ + "static/media/overlay_img_top.443ddda95f4c344145c55786db76c421.svg";
export { ForwardRef as ReactComponent };